import Navbar from "../components/Navbar";
import WebDevHero from "../components/WebDevHero";
import OfferSection from "../components/OfferSection";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";
import CTA from "../components/CTA";
const WebDevelopment = () => {
  return (
    <>
      <Navbar />
      <WebDevHero />
      <OfferSection />
      <WhyChooseUs/>
      <CTA />
      <Footer />
    </>
  );
};

export default WebDevelopment;